<template>
  <AccessErrorBase>
    <template #title>
      Error
    </template>
    <template #errorTitle>
      Error loading sites
    </template>
    <template #errorText>
      {{ siteLoadError }}
    </template>
  </AccessErrorBase>
</template>

<script>
import { mapState } from 'vuex';
import AccessErrorBase from '@/components/common/siteCheck/AccessErrorBase.vue';

export default {
  name: 'ErrorLoadingSites',
  components: {
    AccessErrorBase,
  },
  computed: {
    ...mapState('common', [
      'siteLoadError',
    ]),
  },
};
</script>

<style scoped>

</style>
